module.exports = __webpack_public_path__ + "static/10-mission1-fail-8b219af5163de908db596e93a9398c22.png";